import { languageMapper } from "./languageMapper";
export const getBrowserLocale = (): string => {
  const language = window.navigator.languages
    ? window.navigator.languages[0]
    : window.navigator.language;
  return languageMapper(language);
};
